import { Component } from "react";
import "../dash.css"
import DashHeader from "../../component/dash_header";

import { MdAccountBalanceWallet } from "react-icons/md";
import { Link } from "react-router-dom";
// import axios from "axios";
import FormattedDate from "../../component/dateFormat";
import ChatBox from "../../component/chatbox";
import { connect } from "react-redux";
import AddDeposit from "../../component/add_deposit";
import axios from "axios";
import { fetchUser } from '../../reducer/userActions';
import UserList from "../../component/admin_list_user"
import { GoPaperAirplane } from "react-icons/go";


class AdminDashbaord extends Component {
    state = {
        user: {
            firstName: "",
            lastName: "",
            userPlan: ""
        },
        isMenuVisible: false,
        userInfo: [],
        windowWidth: window.innerWidth,
        loading: false,
        network: false,
        AllUserInfo: [],
        displayDeposit: false,
        selectedUserId: null,
        message: "",
    };

    // Toggles the menu visibility
    toggleMenu = () => {
        this.setState((prevState) => ({
            isMenuVisible: !prevState.isMenuVisible
        }));
    };

    // Handle window resize event
    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    // Adjust menu visibility based on window width
    adjustMenuVisibility = () => {
        const { windowWidth, isMenuVisible } = this.state;
        if (windowWidth > 1100 && !isMenuVisible) {
            this.setState({ isMenuVisible: true });
        } else if (windowWidth <= 1100 && isMenuVisible) {
            this.setState({ isMenuVisible: false });
        }
    };

    // Clean up resize event listener when component unmounts
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    // Update menu visibility when window width changes
    componentDidUpdate(prevProps, prevState) {
        if (prevState.windowWidth !== this.state.windowWidth) {
            this.adjustMenuVisibility();
        }
        // if (prevProps.user !== this.props.user) {
        //     this.setState({ userInfo: this.props.user });
        // }
    }

    componentDidMount() {
        const savedUser = localStorage.getItem("teslaUserInfo");
        if (savedUser) {
            const userData = JSON.parse(savedUser);
            this.setState({
                user: {
                    firstName: userData.firstName || "",
                    lastName: userData.lastName || "",
                    userPlan: userData.userPlan || ""
                }
            });
        }
        window.addEventListener("resize", this.handleResize);
        this.adjustMenuVisibility(); // Initial visibility check
        // this.fetchUserInfo();
        // const { user } = this.props;
        // if (user) {
        //     this.setState({ userInfo: user });
        // }
        this.fetchAllUserInfo()
    }


    fetchAllUserInfo = async () => {
        this.setState({ loading: true });

        const accessToken = localStorage.getItem("teslaUserAccessToken"); // ✅ fixed key name

        try {
            const response = await axios.get("https://teslasafebroker.com/api/admin/userinfo", {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.data && response.data.user && response.data.user.length > 0) {
                const firstUser = response.data.user[0];
                this.setState({
                    AllUserInfo: response.data.user,
                    userInfo: firstUser,   // 👈 set the first user for dashboard view
                    loading: false,
                    selectedUserId: firstUser.uniqueID,
                });
            } else {
                // Fallback if user is not returned (avoid stuck loading)
                this.setState({ loading: false });
            }

            console.log("User information:", response.data.user);

        } catch (error) {
            // Always clear loading state
            this.setState({ loading: false });

            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                // ✅ Make sure to check error.response exists first
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");
                // Optional: redirect or show login expired message
                window.location.href = "/login";
            } else {
                console.error("Error fetching user data:", error);
                this.setState({ network: true }); // optional network error flag
            }
        }
    };

















    handleWithdrawStatus = async (status, id) => {
        this.setState({ loading: true });

        const accessToken = localStorage.getItem("teslaUserAccessToken"); // ✅ fixed key name

        const dataToSend = {
            status: status,
            uniqueID: this.state.selectedUserId
        }
        try {
            const response = await axios.patch(`https://teslasafebroker.com/api/withdraw/crypto/status/${id}`, dataToSend, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.data && response.data.user) {
                this.setState({ loading: false });
                this.fetchAllUserInfo()
            } else {
                // Fallback if user is not returned (avoid stuck loading)
                this.setState({ loading: false });
            }

            console.log("User information:", response.data.user);

        } catch (error) {
            // Always clear loading state
            this.setState({ loading: false });

            if (error.response.status === 401) {
                // ✅ Make sure to check error.response exists first
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");
                // Optional: redirect or show login expired message
                window.location.href = "/login";
            } else {
                console.error("Error fetching user data:", error);
                this.setState({ network: true }); // optional network error flag
            }
        }
    };







    handleDepositDelete = async (id) => {
        this.setState({ loading: true });

        const accessToken = localStorage.getItem("teslaUserAccessToken");

        const dataToSend = {
            uniqueID: this.state.selectedUserId
        };

        try {
            const response = await axios.delete(`https://teslasafebroker.com/api/deposit/crypto/${id}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                data: dataToSend // ✅ for DELETE, body goes inside 'data' field
            });

            if (response.data && response.data.user) {
                this.setState({ loading: false });
                this.fetchAllUserInfo()
            } else {
                this.setState({ loading: false });
            }

            console.log("User after deletion:", response.data.user);

        } catch (error) {
            this.setState({ loading: false });

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");
                window.location.href = "/login";
            } else {
                console.error("Error deleting deposit:", error);
                this.setState({ network: true });
            }
        }
    };







    handleChatMessage = async (e) => {
        e.preventDefault()
        this.setState({ loading: true });

        const accessToken = localStorage.getItem("teslaUserAccessToken"); // ✅ fixed key name

        const dataToSend = {
            message: this.state.message,
           clientUniqueID: this.state.selectedUserId
        }
        try {
            const response = await axios.post(`https://teslasafebroker.com/api/admin/chatbox`, dataToSend, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.data && response.data.user) {
                this.setState({ loading: false, message : "" });
                this.fetchAllUserInfo()
            } else {
                // Fallback if user is not returned (avoid stuck loading)
                this.setState({ loading: false });
            }

            console.log("User information:", response.data.user);

        } catch (error) {
            // Always clear loading state
            this.setState({ loading: false });

            if (error.response.status === 401) {
                // ✅ Make sure to check error.response exists first
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");
                // Optional: redirect or show login expired message
                window.location.href = "/login";
            } else {
                console.error("Error fetching user data:", error);
                this.setState({ network: true }); // optional network error flag
            }
        }
    };








    updateUserInfo = async (e) => {
        e.preventDefault()
        
    try {
        this.setState({loading : true})
        const { userInfo } = this.state;
        const accessToken = localStorage.getItem("teslaUserAccessToken");

        const response = await axios.patch('https://teslasafebroker.com/api/admin/userinfo', {
            uniqueID: this.state.selectedUserId,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            email: userInfo.email,
            phone: userInfo.phone,
            country: userInfo.country,
            password: userInfo.password,
            walletBalance: userInfo.walletBalance,
            walletDeposit: userInfo.walletDeposit,
            userPlan: userInfo.userPlan,
            withdrawerPin: userInfo.withdrawerPin
        }, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

        console.log("User updated:", response.data);
        alert("User updated successfully!");
        this.setState({loading : false})
        this.fetchAllUserInfo()

    } catch (error) {
        console.error("Failed to update user:", error.response?.data || error.message);
        alert("Failed to update user: " + (error.response?.data?.message || error.message));
        this.setState({loading : false})
    }
}








    handleUserSwap = (id) => {
        const user = this.state.AllUserInfo.find(item => item.uniqueID === id);
        if (user) {
            this.setState({
                userInfo: user,
                selectedUserId: id
            });
        }
    }


    displayDepositForm = (value) => {
        this.setState({ displayDeposit: value })
    }


    handleInput = (event) => {
        const { name, value } = event.target
        this.setState((prevState) => ({
            userInfo: {
                ...prevState.userInfo,
                [name]: value
            }
        }));
    }


    handleMessageInput = (event) =>{
        const {name,value} = event.target
        this.setState({
            [name] : value
        })
    }


    handleDelete = async(id) =>{
        this.setState({ loading: true });

        const accessToken = localStorage.getItem("teslaUserAccessToken"); // ✅ fixed key name
         try {
            const response = await axios.delete(`https://teslasafebroker.com/api/admin/userinfo/${id}`, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.data && response.data.user) {
                this.setState({ loading: false });
                this.fetchAllUserInfo()
            } else {
                // Fallback if user is not returned (avoid stuck loading)
                this.setState({ loading: false });
            }

            console.log("User information:", response.data.user);

        } catch (error) {
            // Always clear loading state
            this.setState({ loading: false });

            if (error.response.status === 401) {
                // ✅ Make sure to check error.response exists first
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");
                // Optional: redirect or show login expired message
                window.location.href = "/login";
            } else {
                console.error("Error fetching user data:", error);
                this.setState({ network: true }); // optional network error flag
            }
        }
    }


    render() {
        const { isMenuVisible, user, userInfo, displayDeposit, AllUserInfo, message, loading } = this.state



        const depositList = Array.isArray(userInfo?.deposit) && userInfo.deposit.length > 0
            ? userInfo.deposit.map(list => {
                return (
                    <li key={list.date}>
                        <h5>
                            {list.method}
                            <br />
                            <span><FormattedDate date={list.date} /></span>
                        </h5>
                        <h5>
                            ${list.amount}
                            <br />
                            <button onClick={() => { this.handleDepositDelete(list.date) }}>delete</button>
                        </h5>
                    </li>
                )
            }) : (
                <div className="deposit_contain_list">
                    <MdAccountBalanceWallet />
                    <p>No deposits yet</p>
                    <Link to="/deposit"><button>Deposit Now</button></Link>
                </div>

            )

        const withdrawList = Array.isArray(userInfo?.withdraw) && userInfo.withdraw.length > 0
            ? userInfo.withdraw.map(list => {
                return (
                    <li key={list.id}>
                        <h5>
                            {list.method}
                            <br />
                            <span><FormattedDate date={list.date} /> </span>
                        </h5>
                        <h5>
                            ${list.amount}
                            <br />
                            <span className={`${list.status === "Pending" ? "yellow" : list.status === "Reverse" ? "red" : list.status === "Complete" ? "green" : "yellow"} `}>{list.status}</span>
                        </h5>
                        <h5>
                            <button onClick={() => { this.handleWithdrawStatus("Complete", list.id) }}>Complete</button>
                            <br />
                            <button onClick={() => { this.handleWithdrawStatus("Reverse", list.id) }}>Reverse</button>
                        </h5>
                    </li>
                )
            }) : (
                <div className="deposit_contain_list">
                    <MdAccountBalanceWallet />
                    <p>No withdrawals yet</p>
                    <Link to="/withdrawal"><button>Withdraw</button></Link>
                </div>
            )


            const chatList = Array.isArray(userInfo?.chat) && userInfo.chat.length > 0
            ? userInfo.chat.map(list => {
                return (
                    <li key={list.time} className={list.person === "admin" ? "right" : "left"}>
                        {list.message}
                    </li>
                )
            }) : (
                <div className="deposit_contain_list">
                    <MdAccountBalanceWallet />
                    <p>No deposits yet</p>
                    <Link to="/deposit"><button>Deposit Now</button></Link>
                </div>

            )




        return (
            <div className="dashboard">
                <DashHeader toggleMenu={this.toggleMenu} />
                <div className="dash_body_container">
                    {/* <DashMenu isMenuVisible={isMenuVisible} toggleMenu={this.toggleMenu} /> */}
                    <UserList isMenuVisible={isMenuVisible} toggleMenu={this.toggleMenu} AllUserInfo={AllUserInfo} handleUserSwap={this.handleUserSwap} selectedUserId={this.state.selectedUserId} />
                    <div className="dash_content_container">
                        <div className="dash_contain">
                            <div className="dash_head">
                                <h3 style={{ textTransform: "capitalize" }}>Good Day {`${user.firstName} ${user.lastName}`}</h3>
                                <p>Welcome to Tesla Broker admin dashboard - <Link to="/dashboard"><span style={{color:"rgba(255, 80, 80, 0.7)", textDecoration:"none"}}>Click Here</span></Link> for user dashboard</p>
                            </div>


                            {/*                    

                            <div className="dash_record_container">
                                <nav className="record_contain">
                                    <h4>
                                        $ <NumberDisplay value={userInfo.walletDeposit} />
                                        <br />
                                        <span>Total Deposit</span><br />
                                        <span>BTC <BitcoinConverter value={userInfo.walletDeposit} /></span>
                                    </h4>
                                </nav>
                                <nav className="record_contain">
                                    <h4>
                                        $ <NumberDisplay value={userInfo.walletBalance} />
                                        <br />
                                        <span >Balance</span> <br />
                                        <span>BTC <BitcoinConverter value={userInfo.walletBalance} /></span>
                                    </h4>
                                </nav>
                                <nav className="record_contain">
                                    <h4>
                                        {userInfo.userPlan || ""}
                                        <br />
                                        <span>Crypto Plan</span>
                                    </h4>
                                </nav>
                            </div> */}




                            <div className="dash_table_container">
                                <section className="dash_contain">
                                    <div className="side_dash_table_cover">
                                        <div className="dash_cover">
                                            <h3>Chat User</h3>
                                            <p>This chat is for the selected user </p>
                                            <div className="table_list" style={{ overflow: "hidden" }}>
                                                <div className="chat_body">
                                                    <div>
                                                        {chatList}
                                                    </div>
                                                </div>
                                                <form className="chat_form" onSubmit={this.handleChatMessage}>
                                                    <textarea type="text" name="message" id="message" value={message} onChange={this.handleMessageInput} required />
                                                    <button type="submit" disabled={loading} className="button"><GoPaperAirplane /></button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </section>


                                <section className="dash_contain">
                                    <div className="side_dash_table_cover">
                                        <div className="dash_cover small">
                                            <h3>Deposit <button onClick={() => { this.displayDepositForm(true) }}>Add Deposit</button></h3>
                                            <p>Recent deposit successfully made.</p>
                                            <div className="table_list">

                                                {/* <li>
                                                    <h5>
                                                        Bitcoin
                                                        <br/>
                                                        <span>13/04/2025 10:00</span>
                                                    </h5>
                                                     <p className="amount">$1000.00</p>
                                                </li> */}
                                                {depositList}

                                            </div>
                                        </div>
                                    </div>

                                    <div className="side_dash_table_cover">
                                        <div className="dash_cover small">
                                            <h3>Withdrawal</h3>
                                            <p>Recent withdrawal successfully made.</p>
                                            <div className="table_list">


                                                {withdrawList}

                                            </div>
                                        </div>
                                    </div>


                                </section>
                            </div>





                            <div className="dash_profile_input">
                                <h4>Profile Information</h4>
                                <div className="input_cover">
                                    <div className="input half">
                                        <label> First Name </label>
                                        <input name="firstName" id="firstName" value={userInfo.firstName} onChange={this.handleInput} type="text" placeholder="First Name" />
                                    </div>
                                    <div className="input half">
                                        <label> Last Name </label>
                                        <input name="lastName" id="lastName" value={userInfo.lastName} onChange={this.handleInput} type="text" placeholder="Last Name" />
                                    </div>
                                </div>
                                <div className="input_cover">
                                    <div className="input half">
                                        <label> Email </label>
                                        <input name="email" id="email" value={userInfo.email} onChange={this.handleInput} type="email" placeholder="Email" />
                                    </div>
                                    <div className="input half">
                                        <label>Phone Number</label>
                                        <input name="phone" id="phone" value={userInfo.phone} onChange={this.handleInput} type="tel" placeholder="Phone" />
                                    </div>
                                </div>
                                <div className="input_cover">
                                    <div className="input half">
                                        <label> Country </label>
                                        <input name="country" id="country" value={userInfo.country} onChange={this.handleInput} type="text" placeholder="Country" />
                                    </div>
                                    <div className="input half">
                                        <label> password </label>
                                        <input name="password" id="password" value={userInfo.password} onChange={this.handleInput} type="text" placeholder="Password" />
                                    </div>
                                </div>
                                <div className="input_cover">
                                    <div className="input half">
                                        <label> Wallet Balance </label>
                                        <input name="walletBalance" id="walletBalance" value={userInfo.walletBalance} onChange={this.handleInput} type="number" placeholder="walletBalance " />
                                    </div>
                                    <div className="input half">
                                        <label> Wallet Deposit </label>
                                        <input name="walletDeposit" id="walletDeposit" value={userInfo.walletDeposit} onChange={this.handleInput} type="number" placeholder="walletDeposit" />
                                    </div>
                                </div>
                                <div className="input_cover">
                                    <div className="input half">
                                        <label>  User Plan </label>
                                        <select name="userPlan" id="userPlan" value={userInfo.userPlan} onChange={this.handleInput}>
                                            <option value="Basic">Basic</option>
                                            <option value="Silver">Silver</option>
                                            <option value="Gold">Gold</option>
                                            <option value="Platinum">Platinum</option>
                                        </select>
                                    </div>
                                    <div className="input half">
                                        <label> Withdrawer Pin </label>
                                        <input name="withdrawerPin" id="withdrawerPin" value={userInfo.withdrawerPin} onChange={this.handleInput} type="number" placeholder="withdrawerPin" />
                                    </div>
                                </div>
                                <div className="input_cover">
                                    <div className="input half">
                                        <label>  User Plan </label>
                                        <select name="verified" id="verified" value={userInfo.verified} onChange={this.handleInput}>
                                            <option value="false">false</option>
                                            <option value="true">true</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="button" >
                                    <button onClick={this.updateUserInfo} disabled={loading}>Update Data</button>
                                    <button onClick={() => this.handleDelete(userInfo.uniqueID)} style={{backgroundColor: "rgba(255, 80, 80, 0.7)", color:"white", marginLeft: "10px"}} disabled={loading}>Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ChatBox />

                {displayDeposit &&
                    <AddDeposit uniqueID={userInfo.uniqueID} displayDepositForm={this.displayDepositForm} />
                }

            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    user: state.user,
});



export default connect(mapStateToProps, { fetchUser })(AdminDashbaord)